import React from 'react';
import GeneralContactForm from './GeneralContactForm';
import fountain from '../images/fountain.jpg';
import hug from '../images/hug.jpg';
import header_two_ham from '../images/header_two_ham.jpg';
import Helmet from "react-helmet";

const Buy = () => (
  <div className="full-job-ctn">
    <Helmet>
      <title>Hamilton Homes - Buy with Us</title>
      <meta name="description" content="We simplify your buying processes, and with our expertise, make sure you get what you want for the price you ask!"/>
      <meta name="keywords" content="buying,hamilton,homes,for,sale,niburski,search,condos,luxury,business"/>

      <meta property="og:url" content="https://besthamiltonhouses.com/buy"/>
      <meta property="og:title" content="Hamilton Homes - Buy"/>
      <meta property="og:description" content="We simplify your buying processes, and with our expertise, make sure you get what you want for the price you ask!"/>
    </Helmet>

    <div className="job-outline">
      <div className="full-job-details-stacked listing-page buy-page">
        <div className="heading">
          <h2>Buying With Us</h2>
        </div>

        <div className="steps">
          <div className="step">
            <h3>We Build a Relationship</h3>
            <p>
              Let me help you every step of the way. When purchasing a home, you are faced with a multitude of decisions! The primary one is whether you are actually prepared to purchase a home. Locating the perfect home is not always an easy task, and obtaining a mortgage loan can be a complex and tiring process. Although, once you have determined that you are ready to move forward with the required effort towards your home-purchasing goal, the rewards are unquestionable.
            </p>

            <p>
              While at your side each step of the way, we will make the process of purchasing a home easier, more enjoyable, less time-consuming, and less expensive than if you undertook this challenge on your own. We will help you prepare so that sellers perceive you as a preferred buyer, help you locate and assess properties for sale that match your specifications, and help you through the myriad of details attending the actual purchase.
            </p>

            <p>
              We am always familiar with the current homes on the market, and we know neighborhood values well, so we can help you determine which properties are fairly-priced and in good condition before you start your search.
            </p>
          </div>

          <div className="step">
            <h3>Your first step</h3>
            <p>
              Your first step to buying a home is to first ask yourself why you want to buy a home: to stop paying rent? To start building equity? To have a place of your own? To raise a family? To entertain business associates? To move up to a bigger house? Next, list what kind of home you'd like and where you would like to be. Be specific. Separate the "must haves" from the "want to haves."
            </p>

            <p>
              Think of yourself as zeroing in on a target, going from the general to the specific. Consider area (city, suburban neighborhood, country); community (north, south, east, or west side); neighborhood (older and settled or sparkling new; a particular school zone; recreational facilities; and other community services such as transportation, day care, library, stores, entertainment). Ask yourself how many minutes you are willing to commute to work.
            </p>

            <p>
              Think about home styles. How much space do you need? Does your situation require a one-level home, or are stairs acceptable? Consider size and kind of property. Do you want a newer home, or maybe an older one to fix up? Someday you or your heirs will want to sell. Consider how long you expect to live in this particular home.
            </p>
          </div>

          <div className="step">
            <h3>Your Next Step: Loan Pre-Qualification</h3>
            <p>
              Once you have addressed the above needs, your next step in the purchasing process is to get pre-qualified with a mortgage company. This can be done over the phone or even online in a matter of minutes.
            </p>

            <p>
              Call me and we will refer you to a mortgage professional that has an excellent reputation and track record for successfully acquiring loan approval for his/her clients.
            </p>
          </div>

          <div className="step">
            <h3>We Will Find The Right Homes For You</h3>
            <p>
              Once you've been pre-qualified and know what price range you want to stay in, we can help you determine which properties fit your needs by using the (MLS) Multiple Listing Service system to locate them
            </p>

            <p>
              We have the best possible resources and communication systems available today to help you locate the homes on the market that match your specifications. You can even search our listings here at our website.
            </p>

            <p>
              We will help you complete your financing and inspections, and close on the transaction. My top priority is to make sure that your home buying experience is pleasant, cost-efficient, and successful.
            </p>
          </div>
        </div>

        <GeneralContactForm />

        <br/>
        <br/>
        <br/>
      </div>
    </div>
  </div>
);

export default Buy;
